/* Copyright 2015 Bloomberg Finance L.P.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var widgets = require("jupyter-js-widgets");
var _ = require("underscore");

var TooltipModel = widgets.DOMWidgetModel.extend({

    defaults: _.extend({}, widgets.DOMWidgetModel.prototype.defaults, {
        _model_name: "TooltipModel",
        _view_name: "Tooltip",
        _model_module: "bqplot",
        _view_module: "bqplot",

        fields: [],
        formats: [],
        show_labels: true,
        labels: []
    })
});

module.exports = {
    TooltipModel: TooltipModel
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/TooltipModel.js
 ** module id = 68
 ** module chunks = 0
 **/